import angular from 'angular';

import { changePageTitle } from 'auth/actions/session.actions';
import termsPageModule from './components/terms-page/terms-page-module';
import termsListModule from './components/terms-list/terms-list-module';
import termsDialogModule from './components/terms-dialog/terms-dialog-module';

export default angular.module('terms-preview', [termsPageModule.name, termsListModule.name, termsDialogModule.name]).config([
  '$stateProvider',
  ($stateProvider) => {
    $stateProvider.state('terms', {
      parent: 'arw',
      url: '/terms-and-conditions',
      params: {
        hideMenu: true,
        pageTitle: [
          '$ngRedux',
          'gettextCatalog',
          ($ngRedux, gettextCatalog) => {
            $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Terms & Conditions')));
          },
        ],
      },
      template: '<terms-page></terms-page>',
    });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/terms-preview/terms-preview-module.js